import { ArrowBack, ArrowCircleDownSharp, ArrowCircleRightSharp, ArrowCircleUp, CancelRounded, Sms } from "@mui/icons-material";
import { TextField } from "@mui/material"
import { useContext, useEffect, useState } from "react";
import { CurrentPContext, MasterContext, UserContext } from "../ContextApi/context";
import TopBigSlides from "../DTechComp/TopBigSlides";
import { useHistory } from "react-router-dom";
import InputDubleSet from "../DTechComp/InputDubleSet";
import utilsUsers from "../_Utils/utilsUsers";
import utilsLogInP from "../_Utils/utilsLogInP";
import utilsCodes from "../_Utils/utilsCodes";
import PopUpRegular from "../DTechComp/PopUpRegular";
import PopUpMsg from "../DTechComp/PopUpMsg";
import PopUpClearComp from "../DTechComp/PopUpClearComp";
import UserDetails from "./UserDetails";
import PopUpPhoneCheckCode from "../DTechComp/PopUpPhoneCheckCode";
import ConnUrls from "../Connections/ConnectURL";
import { Helmet } from "react-helmet";
import PopUpsSlides from "../DTechComp/PopUpsSlides";
import WelcomeScreen from "../DTechComp/Pops_Secials/WelcomeScreen/WelcomeScreen";


const LoginPage = (props) => {



    const [master, setMaster] = useContext(MasterContext);
    const [user, setUser, UserEffectFunction] = useContext(UserContext);

    const [topSlides, setTopSlides] = useState(<PopUpsSlides key={"logInPop"} TopImages={master.loginTopImages} />);
    const [thePopUp, setThePopUp] = useState("");
    const [withNumber, setWithNumber] = useState(false);
    const [connectedUser, setConnectedUser] = useState(null);



    const history = useHistory();

    let popTiming = -1;

    useEffect(async () => {


        props.scrollToTop();
        props.shoTopStrp(false);

        checkForPopUp();

    }, [])

    useEffect(async () => {
        if (props.withNumber || withNumber) {
            connectBySms();
        }

    }, [props.withNumber, withNumber])



    //בודק שהקישור הוא לא בקשת התחברות
    //אחרת ישירות מקפיץ פופאפ של התחברות ב
    //SMS
    const checkForPopUp = () => {
        let urStr = document.location.toString();

        if (urStr.includes("popLog")) {
            connectBySms();
        }
    }
    const goToBack = async () => {
        setThePopUp();
        try {
            props.closeMeFuc();
        }
        catch { }


        await UserEffectFunction();


    }


    const regisetMe = (initPhone) => {
        setThePopUp(
            <PopUpClearComp
                popFullComp={"specialPopComp onTopOfAll"}
                cssStyl={"noPadding"}
                btnFStyle={"fatInBtn"}
                closePop={() => setThePopUp()}
                insideCss={"noPadding"}
                theInsideComp={
                    <UserDetails theInsideComp={""}
                        backFunc={true}
                        initPhone={initPhone}
                        onBack={() => setThePopUp()}
                        onRegistered={(usrdet) => connectedMsg(usrdet, true)}
                        closeMeFuc={() => { setThePopUp(); props.closeMeFuc() }}
                        shoTopStrp={(tf) => { }}
                        scrollToTop={(stUp) => { }}
                        connectWithNumber={() => { setThePopUp(); setWithNumber(true) }}
                    />

                } />)
    }

    const connectByEmail = () => {
        popTiming++;
        setThePopUp(
            <InputDubleSet key={popTiming} Title={"התחברות"}
                ContentText={""} inLabel={"כתובת אימייל"} inLabel2={"סיסמא"}
                okClick={(connDetails) => connectUserByMail(connDetails)}
                cancelClick={() => setThePopUp()}
                inputTxt={""}
                inputPrc={""}
                errorMsg={"יש להזין מייל וסיסמא תקינים על מנת להתחבר"}
            />)
    }

    const connectUserByMail = async (connDetails) => {
        popTiming++;
        let details = {
            email: connDetails.inputTxt,
            password: connDetails.inputPrc,
        };

        let connectMe = await utilsLogInP.connectUsr(details);


        if (connectMe.errMsg != "" && connectMe.errMsg != undefined) {
            setThePopUp(
                <InputDubleSet key={popTiming} Title={"התחברות"}
                    ContentText={""} inLabel={"כתובת אימייל"} inLabel2={"סיסמא"}
                    okClick={(connDet) => connectUserByMail(connDet)}
                    cancelClick={() => setThePopUp()}
                    showError={true}
                    inputTxt={details.email}
                    inputPrc={details.password}
                    errorMsg={connectMe.errMsg}
                />)
        }
        else {
            setUser(connectMe);
            connectedMsg(connectMe);
        }
    }


    // הטלפון מוזן בחלון הפתיחה עצמו - רק סוגרים את מה שפתוח מעליו
    const connectBySms = () => {
        setThePopUp();
    }

    // נקרא מחלון הפתיחה. שגיאה חוזרת לחלון ומוצגת בו
    const checkConCode = async (phoneNum) => {
        let codeReply = await utilsCodes.createCodeSms(phoneNum);
        if (codeReply.errormsg) {
            return {
                errMsg: codeReply.errormsg,
                notRegistered: codeReply.errormsg.includes("לא נמצא משתמש")
            };
        }
        showCodePop(codeReply.nId, phoneNum, "");
    }

    const resendCode = async (phoneNum) => {
        let res = await checkConCode(phoneNum);
        if (res && res.errMsg) setThePopUp();
    }

    const showCodePop = (nId, phoneNum, errMsg) => {
        popTiming++;
        setThePopUp(
            <PopUpPhoneCheckCode key={Date.now()} Title={["הזינו את הקוד"]}
                cssStyl={`onTopOfAll specialContactPop`}
                topSlides={null}
                placeholdTxtF="קוד בן 6 ספרות"
                ContentText={[`שלחנו קוד ב-SMS למספר ${phoneNum}`]} inLabel={""}
                okClick={(codeCheck) => checkForSMSConCode(codeCheck, nId, phoneNum)}
                cancelClick={() => setThePopUp()}
                recreateCode={() => resendCode(phoneNum)}
                showError={!!errMsg}
                errorMsg={errMsg}
            />
        )
    }


    const checkForSMSConCode = async (codeCheck, nId, phoneNum) => {
        let connectMe = await utilsCodes.checkConnCode(nId, { codeCheck, phoneNum });

        if (connectMe.errMsg != "" && connectMe.errMsg != undefined) {
            showCodePop(nId, phoneNum, connectMe.errMsg);
        }
        else {

            setUser(connectMe);
            connectedMsg(connectMe);
        }
    }

    // הודעת "התחברת" מחליפה את חלון הפתיחה באותו מקום - כל החלונות של ההתחברות נסגרים
    const connectedMsg = (usrdet, isNew) => {
        setThePopUp();
        setConnectedUser({ ...usrdet, isNew: !!isNew });
        setTimeout(() => { goToBack() }, 5000)
    }



    return (
        <div className={"loginPage"}>
          
            {connectedUser ?
                <div className="ws-backdrop" dir="rtl">
                    <div className="ws-card" role="status">
                        <div className="roundWrap">
                            <img src={`${ConnUrls.media(master.suceccufulyconnectedImg)}`} alt="" />
                        </div>
                        <div className="bold ws-title arrowing">היי {connectedUser.firstName}</div>
                        <div className="ws-desc arrowing">{connectedUser.isNew ? "שמחים שהצטרפת אלינו!" : "שמחים שאתה כאן!"}</div>
                        <button type="button" className="ws-btn ws-btn-primary" onClick={() => goToBack()}>המשך</button>
                    </div>
                </div>
                :
                 <WelcomeScreen
                  isOpen={true}
                //   icon="ice-cream-2"
                  title="ברוכים הבאים"
                  description="לאפליקציה המקומית אשדוד בתפריט. אנחנו דואגים שכל מנה תהיה הכי משתלמת בסביבה."
                  headerLabel="התחברות"
                  newUserLabel="להרשמה"
                  onBack={() => goToBack()}
                  backClose={props.closeMeFuc ? () => goToBack() : null}
                  onSendCode={(phoneNum) => checkConCode(phoneNum)}
                  onNewUser={(phoneNum) => { regisetMe(phoneNum) }}
                />
            }
          
            {thePopUp}

            <Helmet
                meta={[
                    {
                        property: "og:url", content: `${ConnUrls.siteDomainNam}/LoginPage`
                    }
                ]}>
                <link rel="canonical" href={`${ConnUrls.siteDomainNam}/LoginPage`} />
            </Helmet>
        </div>
    )

}

export default LoginPage